import { render } from "./Suggestions.vue?vue&type=template&id=37adc013&scoped=true&ts=true"
import script from "./Suggestions.vue?vue&type=script&lang=ts"
export * from "./Suggestions.vue?vue&type=script&lang=ts"

import "./Suggestions.vue?vue&type=style&index=0&id=37adc013&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37adc013"]])

export default __exports__